import axios from 'axios'
import { _baseDeleteFetch, _baseGetFetch, _basePostFetch, _basePutFetch, ApiEnum } from './baseFetch'

const path = '/products/models'
const pageLimit = 20

// ---------------------------Variants----------------------------
export const getProductModelsFilterOptions = async () => {
  return _baseGetFetch(`${path}/filters-options`, undefined, ApiEnum.admin)
}

export const getProductModelsVariants = async (queryParams) => {
  return _baseGetFetch(`${path}/variants`, { ...queryParams, maxResults: pageLimit }, ApiEnum.admin)
}

export const updateProductModelsVariantsById = async (modelId, variantsId, body) => {
  return _basePutFetch(`${path}/${modelId}/variants/${variantsId}`, body, ApiEnum.admin)
}

export const addProductModelsVariants = async (modelId, body) => {
  return _basePostFetch(`${path}/${modelId}/variants`, body, ApiEnum.admin)
}

export const deleteProductModelsVariantsById = async (modelId, variantsId, body) => {
  return _baseDeleteFetch(`${path}/${modelId}/variants/${variantsId}`, body, ApiEnum.admin)
}

export const downloadModelVariants = async (bodyParams) => {
  return _baseGetFetch(`${path}/variants/download`, { ...bodyParams }, ApiEnum.admin)
}

// ---------------------------Product Types----------------------------
export const getAdminProductTypes = async (queryParams) => {
  return _baseGetFetch(`/products/types`, { ...queryParams, maxResults: pageLimit }, ApiEnum.admin)
}

export const getAdminProductTypesById = async (id) => {
  return _baseGetFetch(`/products/types/${id}`, undefined, ApiEnum.admin)
}

export const addAdminProductTypes = async (body) => {
  return _basePostFetch(`/products/types`, body, ApiEnum.admin)
}

export const updateAdminProductTypesById = async (id, body) => {
  return _basePutFetch(`/products/types/${id}`, body, ApiEnum.admin)
}

export const deleteAdminProductTypesById = async (id) => {
  return _baseDeleteFetch(`/products/types/${id}`, undefined, ApiEnum.admin)
}

// ---------------------------Models----------------------------
export const getProductModels = async (queryParams) => {
  return _baseGetFetch(`${path}`, { ...queryParams, maxResults: pageLimit }, ApiEnum.admin)
}

export const getProductModelsById = async (id) => {
  return _baseGetFetch(`${path}/${id}`, undefined, ApiEnum.admin)
}

export const addProductModels = async (body) => {
  return _basePostFetch(`${path}`, body, ApiEnum.admin)
}

export const updateProductModelsById = async (id, body) => {
  return _basePutFetch(`${path}/${id}`, body, ApiEnum.admin)
}

export const deleteProductModelsById = async (id) => {
  return _baseDeleteFetch(`${path}/${id}`, undefined, ApiEnum.admin)
}

// ---------------------------Images----------------------------
export const getProductModelsImages = async (queryParams) => {
  return _baseGetFetch(`${path}/images`, { ...queryParams, maxResults: pageLimit }, ApiEnum.admin)
}

export const addProductModelsImages = async (modelId, body) => {
  return _basePostFetch(`${path}/${modelId}/images`, body, ApiEnum.admin)
}

export const deleteProductModelsImagesById = async (modelId, id, body) => {
  return _baseDeleteFetch(`${path}/${modelId}/images/${id}`, body, ApiEnum.admin)
}

export const getImagesSignedUrl = async (queryParams) => {
  return _baseGetFetch(`/products/models/images/signed-url`, queryParams, ApiEnum.admin)
}

export const deleteImagesSignedUrl = async (queryParams) => {
  return _baseDeleteFetch(`/products/models/images/signed-url`, queryParams, ApiEnum.admin)
}

export const putAdminModelImage = async (url, data, fileType) => {
  return await axios.put(url, data, {
    headers: {
      'Content-Type': `image/${fileType}`,
    },
  })
}
